import { render, staticRenderFns } from "./DetailEdit.vue?vue&type=template&id=2fad7f2a&scoped=true&"
import script from "./DetailEdit.vue?vue&type=script&lang=js&"
export * from "./DetailEdit.vue?vue&type=script&lang=js&"
import style0 from "./DetailEdit.vue?vue&type=style&index=0&id=2fad7f2a&lang=scss&scoped=true&"
import style1 from "./DetailEdit.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fad7f2a",
  null
  
)

export default component.exports